module.exports = __webpack_public_path__ + "img/dynamicEnvironmentalMonitoring.ca053148.svg";